// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__25umJ","requiredAsterisk":"Info_requiredAsterisk__lG0sC"};